import { Box, Container, Stack, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useLoaderData } from 'react-router-dom';
import noImage from './no_image.png';
import { includedInTier } from '../../utils';
import ModalHandler from '../ModalHandler/ModalHandler';
import Spot from '../Spot/Spot';

const Profile = () => {
  const theme = useTheme();
  const isLargeUp = useMediaQuery(theme.breakpoints.up('lg'));
  const isMediumDown = useMediaQuery(theme.breakpoints.down('md'));
  const spot = useLoaderData();
  const avatarUrl = spot?.profile_photo_url || spot?.user?.profile_photo_url;

  return (
    <Box sx={{
      display: 'flex',
      marginTop: '1rem'
    }}>
      <Container>
        <Stack direction={isLargeUp ? 'row' : 'column'} spacing={2}>
          <img
            src={includedInTier('avatar', spot) ? (avatarUrl || noImage) : noImage}
            alt={spot.name}
            style={{
              maxHeight: 500,
              maxWidth: 500,
              ...(isMediumDown && {
                maxHeight: '100%',
                maxWidth: '100%'
              })
            }}
          />
          <Box>
            <Spot.Header spot={spot} />
            <Box sx={{ height: '1rem' }} />
            <Spot.Content spot={spot} hideProfileButton />
          </Box>
        </Stack>
      </Container>
      <ModalHandler isLargeUp={isLargeUp} spot={spot} />
    </Box>
  );
};

export default Profile;
